module.exports = __webpack_public_path__ + "static/media/marketplace-logo.02b294c2.png";